import React from 'react';
import ReproRequestAdminSingleView from './ReproRequestAdminSingleView.js';

/**
 * Render the ownership-scoped Reprographics request detail view for requesters.
 */
export default function ReproRequestUserSingleView() {
  return <ReproRequestAdminSingleView requesterMode />;
}
